// Page collection : tiroir de filtres, tri, et « Charger plus » qui
// ajoute la page suivante sans recharger la page entiere.

const sobre = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

class MxCollection extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.grille = this.querySelector('[data-grille]');
    this.annonce = this.querySelector('[data-annonce]');

    this.brancheTiroir();
    this.brancheTri();
    this.brancheChargerPlus();
  }

  /* ---------- Tiroir des filtres ---------- */
  brancheTiroir() {
    const tiroir = this.querySelector('[data-filtres]');
    const voile = this.querySelector('[data-voile-filtres]');
    const ouvreur = this.querySelector('[data-ouvre-filtres]');
    if (!tiroir || !voile || !ouvreur) return;

    const ouvre = () => {
      tiroir.hidden = false;
      voile.hidden = false;
      requestAnimationFrame(() => {
        tiroir.dataset.ouvert = 'true';
        voile.dataset.ouvert = 'true';
      });
      ouvreur.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      tiroir.querySelector('button, input, a')?.focus();
    };

    const ferme = () => {
      tiroir.dataset.ouvert = 'false';
      voile.dataset.ouvert = 'false';
      ouvreur.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      const apres = () => { tiroir.hidden = true; voile.hidden = true; };
      if (sobre()) apres(); else setTimeout(apres, 300);
      ouvreur.focus();
    };

    ouvreur.addEventListener('click', ouvre);
    voile.addEventListener('click', ferme);
    tiroir.querySelector('[data-ferme-filtres]')?.addEventListener('click', ferme);
    document.addEventListener('keydown', (ev) => {
      if (ev.key === 'Escape' && tiroir.dataset.ouvert === 'true') ferme();
    });

    // Le formulaire construit l'adresse filtree et navigue.
    const forme = this.querySelector('[data-forme-filtres]');
    forme?.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const params = new URLSearchParams(new FormData(forme));

      // Les champs de prix vides ne doivent pas se retrouver dans l'adresse.
      for (const [cle, valeur] of [...params]) {
        if (valeur === '') params.delete(cle);
      }

      const base = location.pathname;
      const requete = params.toString();
      location.href = requete ? `${base}?${requete}` : base;
    });
  }

  /* ---------- Tri ---------- */
  brancheTri() {
    this.querySelector('[data-tri]')?.addEventListener('change', (ev) => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', ev.target.value);
      // Un changement de tri repart de la premiere page.
      url.searchParams.delete('page');
      location.href = url.toString();
    });
  }

  /* ---------- Charger plus ---------- */
  brancheChargerPlus() {
    const bouton = this.querySelector('[data-charger-plus]');
    if (!bouton || !this.grille) return;

    bouton.addEventListener('click', async () => {
      const suivante = bouton.dataset.url;
      if (!suivante) return;

      bouton.disabled = true;
      const libelle = bouton.textContent;
      bouton.textContent = 'Chargement…';
      this.dataset.occupe = 'true';

      try {
        const url = new URL(suivante, location.origin);
        url.searchParams.set('section_id', this.sectionId);

        const rep = await fetch(url);
        if (!rep.ok) throw new Error(rep.status);

        const frais = new DOMParser().parseFromString(await rep.text(), 'text/html');
        const nouvelles = frais.querySelectorAll('[data-grille] > *');

        const avant = this.grille.children.length;
        nouvelles.forEach((carte) => this.grille.appendChild(carte));

        if (this.annonce) {
          this.annonce.textContent = `${this.grille.children.length - avant} bonbons de plus affichés.`;
        }

        // Le bouton de la page suivante devient celui de la page d'apres.
        const suivant = frais.querySelector('[data-charger-plus]');
        if (suivant) {
          bouton.dataset.url = suivant.dataset.url;
          bouton.textContent = libelle;
          bouton.disabled = false;
        } else {
          bouton.closest('.mx-charger').hidden = true;
        }

        // Met l'adresse a jour pour que le retour arriere reste coherent.
        const visible = new URL(location.href);
        visible.searchParams.set('page', new URL(suivante, location.origin).searchParams.get('page'));
        history.replaceState({}, '', visible);
      } catch (e) {
        console.error('Collection : chargement de la page suivante impossible', e);
        bouton.textContent = libelle;
        bouton.disabled = false;
      } finally {
        this.dataset.occupe = 'false';
      }
    });
  }
}

customElements.define('mx-collection', MxCollection);
